import React from 'react'
import { awardType } from '../strings/types'
import {
  contractNumberLabel,
  grantNumberLabel,
  executiveDirectorLabel,
  optionalLabel
} from '../strings/labels'

// Define the fields for Grant
let grantConditional = {
  value: awardType.grant,
  fields: [
    {
      type: 'text',
      label: grantNumberLabel,
      name: 'award_number',
      requirementLabel: optionalLabel
    },
    {
      type: 'text',
      label: executiveDirectorLabel,
      name: 'executive_director',
      requirementLabel: optionalLabel
    }
  ]
}

// Define the fields for Contract
let contractConditional = {
  value: awardType.contract,
  fields: [
    {
      type: 'text',
      label: contractNumberLabel,
      name: 'award_number',
      requirementLabel: optionalLabel
    },
    {
      type: 'text',
      label: executiveDirectorLabel,
      name: 'executive_director',
      requirementLabel: optionalLabel
    }
  ]
}

export const awardsField = {
  type: 'repeatable',
  label: 'Grants/Contracts',
  name: 'awards',
  addButton: {
    text: '+ Add another grant/contract',
    variation: 'transparent'
  },
  deleteButton: {
    text: '- Remove grant/contract'
  },
  fields: [
    {
      type: 'radio',
      name: 'award_type',
      choices: [
        { label: awardType.grant, value: awardType.grant },
        { label: awardType.contract, value: awardType.contract }
      ],
      label: 'Are you reporting about a grant or a contract?',
      conditionals: [grantConditional, contractConditional]
    }
  ]
}
